import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivateChild } from '@angular/router';

import { Observable } from 'rxjs';

import { SharedSettings } from '../models/shared-settings';

@Injectable({
    providedIn: 'root'
})
export class FeatureGuard implements CanActivate, CanActivateChild {

    constructor(private settings: SharedSettings) {}

    canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot):
            Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        const featureChecks: boolean[] = [];

        let r = route;

        while (r) {
            if ('feature' in r.data)
                featureChecks.push(this.settings.features[r.data.feature]);

            r = r.parent;
        }

        if (featureChecks.length)
            return featureChecks.every(f => f);
        else
            return true;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
            Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.canActivate(route, state);
    }
}
